import React, { useState, useEffect, useCallback, useRef } from "react";
import CustomTimeSheetTableRow from "./CustomTimeSheetTableRow";
import WeekPicker from "./WeekPicker";
import {
  createTimesheetModal,
  CreateUpdateTimeSheetPayload,
  DaysResponse,
  HourModel,
  MissingTimesheet,
} from "../model/timesheet";
import {
  getCookieData,
  // getUserIdTokenForIonTime,
  setCookieData,
} from "../helper/api";
import moment from "moment";
import ApproveRejectForm from "../pages/IonTime/report/approveRejectForm";
import { useLoading } from "../context/LoadingContext";
import {
  daysDataEnum,
  ReportFormButtonPermissionStatusEnum,
  ReportStatusEnum,
} from "../helper/constant";
import { useReportTimesheetContext } from "../context/ReportTimsheetContex";
import { validateTime } from "../helper/convertionHealper";
// import { printDocument } from "../helper/pdfHealper";
import { useNavigate } from "react-router-dom";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { exportTimesheetPDF } from "../helper/exportTimesheetPDF";
import BackButton from "../components/BackButton";

interface TimeSheetPros {
  modelClose?: () => void;
  memberID?: number;
  startDate?: Date;
  endDate?: Date;
  reportType: string;
  showapproveReject: boolean;
  userRoleType: string;
  employeeNameData?: string;
  employeeIDData?: number | null;
  showExportButton?: boolean;
  showHomeButton?: boolean;
  previewFlag?: boolean;
}

const getWeekDates = (startOfWeek: Date) => {
  const weekDates = [];
  startOfWeek = new Date(startOfWeek);
  startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());

  for (let i = 0; i < 7; i++) {
    const date = new Date(startOfWeek);
    date.setDate(startOfWeek.getDate() + i);
    weekDates.push(date);
  }

  return weekDates;
};

const getInitialHours = (week: Date) => {
  const weekDates = getWeekDates(week);
  return weekDates
    ? weekDates.map((date) => {
        const formattedDate = moment(date).format("DD-MM-YYYY");
        const dayOfWeek = date.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
        let display;
        if (dayOfWeek === 0 || dayOfWeek === 6) {
          display = "Week end";
        } else if (dayOfWeek === 1) {
          display = "Week Start";
        } else {
          display = "Week day";
        }
        return {
          date: formattedDate,
          hours: "",
          rejected: false,
          display: display,
        };
      })
    : [];
};

const CustomTimeSheetTable: React.FC<TimeSheetPros> = ({
  modelClose,
  memberID,
  startDate,
  endDate,
  showapproveReject = false,
  userRoleType = "",
  employeeNameData = "",
  employeeIDData = null,
  showExportButton = false,
  showHomeButton = true,
  // previewFlag = false,
}) => {
  const query = getCookieData("timesheetsReport");
  const cookeei = query ? JSON.parse(query) : null;
  const { isLoading } = useLoading();
  const { activity, getTimesheetAllData, createTimeSheet, timesheetHistory } =
    useReportTimesheetContext();
  // const getUserId =
  //   memberID !== undefined && memberID !== null && !Number.isNaN(memberID)
  //     ? Number(memberID)
  //     : null;
  // console.log("CustomTimeSheetTable", memberID, startDate, endDate);
  const [missingTimeSheet, setMissingTimeSheet] = React.useState<
    MissingTimesheet[] | null
  >(null);
  const [selectedWeek, setSelectedWeek] = useState<Date>(
    startDate ?? new Date(),
  );
  const [isNextWeekDisabled, setIsNextWeekDisabled] = useState(false);
  const [holidaysData, setHolidaysData] = useState<string[]>([]);
  const [checkResponseData, SetCheckResponseData] = useState<boolean>(false);

  const navigate = useNavigate();

  const initialEntry = {
    project_activity_ids: "",
    task_description: "",
    days_data: getInitialHours(selectedWeek),
  };

  const [timesheetData, setTimesheetData] = useState<createTimesheetModal[]>([
    initialEntry,
  ]);
  const [errorMessages, setErrorMessages] = useState<string>("");

  // const isValidHourFormat = (hour: string) => {
  //   const regex = /^([01]?[0-9]|2[0-3]).[0-5][0-9]$/;
  //   return regex.test(hour);
  // };

  const getTimeSheet = useCallback(
    async (
      getpayload: { start_date: string; end_date: string; user_id: number },
      date: Date,
    ) => {
      // console.log("api call", getpayload);
      const emptyData = { ...initialEntry, days_data: getInitialHours(date) };
      setTimesheetData([emptyData]);
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const timesheetResponseData: any =
          await getTimesheetAllData(getpayload);
        SetCheckResponseData(timesheetResponseData ? false : true);
        // console.log('timesheetResponseData ===> ', timesheetResponseData)
        if (timesheetResponseData != null) {
          // Process holidays data if present in the API response
          const holidayArray: string[] = [];
          timesheetResponseData?.days_data?.forEach(
            (item: { day_types_id: number; date: moment.MomentInput }) => {
              if (item.day_types_id === daysDataEnum.HOLIDAY) {
                holidayArray.push(
                  moment(item.date).format("DD-MM-YYYY").toLowerCase(),
                );
              }
            },
          );
          setHolidaysData(holidayArray);

          // if (reportType === "update" && timesheetResponseData?.missing_timesheet && timesheetResponseData?.missing_timesheet.length > 0) {
          //   const missingTimesheetRecord = timesheetResponseData?.missing_timesheet ?? null;
          //   setSelectedWeek(
          //     missingTimesheetRecord[0].end_date ? new Date(missingTimesheetRecord[0].end_date) : new Date(),
          //   );
          // }

          setMissingTimeSheet(timesheetResponseData?.missing_timesheet ?? null);

          // Process last activities data if present in the API response
          if (timesheetResponseData?.last_act?.length > 0) {
            setTimesheetData((prevData) => {
              const filteredData = prevData.filter(
                (item) =>
                  item.project_activity_ids !== "" ||
                  item.task_description !== "",
              );

              return [
                ...filteredData,
                ...timesheetResponseData.last_act.map(
                  (item: { id: string; description: string }) => ({
                    ...item,
                    task_description: item.description,
                    days_data: getInitialHours(date),
                    project_activity_ids: item.id,
                  }),
                ),
                emptyData,
              ];
            });
          }

          // Process values data if present in the API response
          if (timesheetResponseData?.values?.length > 0) {
            setTimesheetData((prevData) => {
              const filteredData = prevData.filter(
                (item) =>
                  item.project_activity_ids !== "" ||
                  item.task_description !== "",
              );

              return [
                ...filteredData,
                ...timesheetResponseData.values.map(
                  (item: {
                    days_data: DaysResponse[];
                    project_id: number;
                    version_id: number;
                  }) => ({
                    ...item,
                    days_data: item.days_data.map((day) => ({
                      ...day,
                      hours:
                        day.hours === "00:00" || day.hours === "0:00"
                          ? " "
                          : day.hours.replace(":", "."),
                    })),
                    project_activity_ids: `${item.project_id}-${item.version_id}`,
                  }),
                ),
                emptyData,
              ];
            });
          }
        }
      } catch (error) {
        // console.error("Error processing timesheet data:", error);
      }
    },
    [getTimesheetAllData, initialEntry],
  );

  // Guard to avoid duplicate initial fetch in dev StrictMode cycles
  const initialLoadRef = useRef(false);

  useEffect(() => {
    if (initialLoadRef.current) return;
    initialLoadRef.current = true;
    if (startDate && endDate) {
      const currentDate = new Date();
      const nextWeek = new Date(startDate);
      nextWeek.setDate(nextWeek.getDate() + 7);
      setIsNextWeekDisabled(nextWeek > currentDate);

      // Calculate first and last day using cloned dates to avoid mutating props
      const firstDayOfWeek = new Date(startDate);
      firstDayOfWeek.setDate(
        firstDayOfWeek.getDate() - firstDayOfWeek.getDay(),
      );

      const lastDayOfWeek = new Date(firstDayOfWeek);
      lastDayOfWeek.setDate(lastDayOfWeek.getDate() + 6);

      const getpayload = {
        start_date: moment(firstDayOfWeek).format("DD-MM-YYYY"),
        end_date: moment(lastDayOfWeek).format("DD-MM-YYYY"),
        user_id: Number(memberID),
      };
      getTimeSheet(getpayload, firstDayOfWeek);
    }
  }, [startDate, endDate, memberID]);
  // Initial effect replaced with guarded version above to prevent duplicate fetches in StrictMode

  const onNextWeek = () => {
    const currentDate = new Date();
    const nextWeek = new Date(selectedWeek);
    nextWeek.setDate(nextWeek.getDate() + 7);
    const check = nextWeek > currentDate;
    setIsNextWeekDisabled(nextWeek > currentDate);
    if (!check && selectedWeek) {
      if (nextWeek <= currentDate) {
        // Calculate first and last day of the next week
        const firstDayOfWeek = new Date(nextWeek);
        firstDayOfWeek.setDate(
          firstDayOfWeek.getDate() - firstDayOfWeek.getDay(),
        ); // Assuming week starts on Monday
        const lastDayOfWeek = new Date(firstDayOfWeek);
        lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6); // Last day is Sunday
        const getpayload = {
          start_date: moment(firstDayOfWeek).format("DD-MM-YYYY"),
          end_date: moment(lastDayOfWeek).format("DD-MM-YYYY"),
          user_id: Number(memberID),
        };
        getTimeSheet(getpayload, nextWeek);
        setSelectedWeek(nextWeek);
        setCookieData(
          "timesheetsReport",
          JSON.stringify({
            id:
              moment(firstDayOfWeek).format("D MMM YYYY") +
              " - " +
              moment(lastDayOfWeek).format("D MMM YYYY"),
            memberID: memberID,
            role: cookeei?.role ?? "",
          }),
        );
      } else {
        // console.log("Cannot move to a future week.");
      }
    }
  };

  const onPrevWeek = () => {
    if (selectedWeek) {
      const prevWeek = new Date(selectedWeek);
      prevWeek.setDate(prevWeek.getDate() - 7);
      setIsNextWeekDisabled(prevWeek > new Date());
      // Calculate first and last day of the next week
      const firstDayOfWeek = new Date(prevWeek);
      firstDayOfWeek.setDate(
        firstDayOfWeek.getDate() - firstDayOfWeek.getDay(),
      ); // Assuming week starts on Monday
      const lastDayOfWeek = new Date(firstDayOfWeek);
      lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6); // Last day is Sunday
      const getpayload = {
        start_date: moment(firstDayOfWeek).format("DD-MM-YYYY"),
        end_date: moment(lastDayOfWeek).format("DD-MM-YYYY"),
        user_id: Number(memberID),
      };
      getTimeSheet(getpayload, prevWeek);
      setCookieData(
        "timesheetsReport",
        JSON.stringify({
          id:
            moment(firstDayOfWeek).format("D MMM YYYY") +
            " - " +
            moment(lastDayOfWeek).format("D MMM YYYY"),
          memberID: memberID,
          role: cookeei?.role ?? "",
        }),
      );
      setSelectedWeek(prevWeek);
    }
  };

  const calculateTotalHoursPerDay = useCallback(
    (dayIndex: number) => {
      let totalHours = 0;
      let totalMinutes = 0;
      timesheetData.forEach((row) => {
        if (row.days_data[dayIndex]) {
          const [hours, minutes] = row.days_data[dayIndex].hours
            .split(".")
            .map(Number);
          totalHours += hours;
          totalMinutes += minutes || 0;
        }
      });

      totalHours += Math.floor(totalMinutes / 60); // Add extra hours from minutes
      totalMinutes = totalMinutes % 60; // Calculate remaining minutes

      return `${totalHours}:${totalMinutes.toString().padStart(2, "0")}`;
    },
    [timesheetData],
  );

  const validateData = useCallback(() => {
    const errors: string[] = [];
    setErrorMessages("");

    if (timesheetData.length === 1) {
      errors.push("Add the project - activity.");
    }

    timesheetData.slice(0, -1).forEach((row) => {
      if (row.project_id === null) {
        errors.push("Project Activity is required.");
        return;
      }
      if (row.task_description.trim() === "") {
        errors.push("Description is required.");
      }

      // Group by day
      row.days_data.forEach((day, index) => {
        const time = calculateTotalHoursPerDay(index);
        const hoursValidation = validateTime(time, day.date);
        if (hoursValidation) {
          errors.push(hoursValidation);
        }
      });
    });
    setErrorMessages(errors[0]);

    return errors.length === 0;
  }, [timesheetData, calculateTotalHoursPerDay, validateTime]);

  const handleSubmitPayload = async (report_statusesid: number) => {
    if (selectedWeek) {
      setErrorMessages("");
      const timesheet = timesheetData.slice(0, -1);
      const firstDayOfWeek = new Date(selectedWeek);
      firstDayOfWeek.setDate(
        firstDayOfWeek.getDate() - firstDayOfWeek.getDay(),
      );

      // Calculate last day of the selected week
      const lastDayOfWeek = new Date(firstDayOfWeek);
      lastDayOfWeek.setDate(lastDayOfWeek.getDate() + 6);

      if (timesheet && memberID) {
        const savePayload: CreateUpdateTimeSheetPayload[] = timesheet.map(
          (item) => ({
            user_id: Number(memberID),
            project_id: Number(item.project_activity_ids.split("-")[0]),
            version_id: Number(item.project_activity_ids.split("-")[1]),
            report_statuses_id: report_statusesid,
            start_date: moment(firstDayOfWeek).format("MM-DD-YYYY"),
            end_date: moment(lastDayOfWeek).format("MM-DD-YYYY"),
            task_description: item.task_description,
            project_activity_ids: item.project_activity_ids,
            days_data: item.days_data.map((day) => ({
              date: day.date,
              hours:
                day.hours === " " || day.hours === ""
                  ? "0:00"
                  : day.hours.includes(".")
                    ? day.hours.replace(".", ":")
                    : day.hours,
            })),
          }),
        );

        await createTimeSheet(savePayload);
      }
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const startOfWeek = (date: Date) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() - newDate.getDay());
    return newDate;
  };

  const endOfWeek = (date: Date) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() - newDate.getDay() + 6);
    return newDate;
  };

  // const onExport = (elementId: string) => {
  //   const formattedStartDate = startOfWeek(selectedWeek).toLocaleDateString("en-US", {
  //     month: "short",
  //     day: "numeric",
  //     year: "numeric",
  //   });

  //   const formattedEndDate = endOfWeek(selectedWeek).toLocaleDateString("en-US", {
  //     month: "short",
  //     day: "numeric",
  //     year: "numeric",
  //   });
  //   printDocument(
  //     elementId,
  //     `${formattedStartDate} - ${formattedEndDate}`,
  //     timesheetHistory?.data
  //       ?.filter((item) => item?.report_statuses_id === ReportStatusEnum.Waitingforapproval)
  //       .map((item) => item.status_user_id)[0] ?? "", // Ensure the third argument is always an array
  //     0,
  //     timesheetHistory?.data
  //       ?.filter(
  //         (item) =>
  //           item?.report_statuses_id === ReportStatusEnum.Approved ||
  //           item?.report_statuses_id === ReportStatusEnum.PartiallyApproved,
  //       )
  //       .map((item) => item.status_user_id)
  //       .join(", ") ?? "", // Ensure the last argument is always a string
  //       "landscape" // ⬅ added this line
  //   );
  //   // console.log("Export logic");
  // };

  const rejectedDate =
    timesheetData[0]?.report_statuses_id === ReportStatusEnum.Approved
      ? null
      : timesheetHistory?.data
          ?.filter(
            (item) =>
              item.report_statuses_id === ReportStatusEnum.Returnedforreview,
          )
          .map((item) => item.rejected_dates.split(",").map(Number))[0] || [];

  const onExport = (elementId: string) => {
    console.log("Exporting to PDF...", elementId);
    const formattedStartDate = startOfWeek(selectedWeek).toLocaleDateString(
      "en-US",
      {
        month: "short",
        day: "numeric",
        year: "numeric",
      },
    );

    const formattedEndDate = endOfWeek(selectedWeek).toLocaleDateString(
      "en-US",
      {
        month: "short",
        day: "numeric",
        year: "numeric",
      },
    );

    const statusHistory =
      timesheetHistory?.data.map((item) => {
        if (
          item.report_statuses_id === ReportStatusEnum.Approved ||
          item.report_statuses_id === ReportStatusEnum.PartiallyApproved
        ) {
          return {
            type: "approved" as const,
            date: moment(item.status_create_ts).format("DD-MM-YYYY HH:mm:ss"),
            by: item.status_user_id,
            remark: item.rejected_reason,
          };
        } else if (
          item.report_statuses_id === ReportStatusEnum.Returnedforreview
        ) {
          return {
            type: "rejected" as const,
            date: moment(item.status_create_ts).format("DD-MM-YYYY HH:mm:ss"),
            by: item.status_user_id,
            remark: item.rejected_reason,
            rejectedDates: item.rejected_dates,
          };
        } else {
          return {
            type: "submitted" as const,
            date: moment(item.status_create_ts).format("DD-MM-YYYY HH:mm:ss"),
            by: item.status_user_id,
          };
        }
      }) || [];

    const weekDateObjects = getWeekDates(selectedWeek);
    const rejectedDays = Array.isArray(rejectedDate) ? rejectedDate : [];
    const weekMeta = weekDateObjects.map((date, index) => {
      const formattedDate = moment(date).format("DD-MM-YYYY");
      const dayOfMonth = date.getDate();
      const isWeekend = index === 0 || index === weekDateObjects.length - 1;
      const isHoliday = holidaysData.includes(formattedDate);
      const isRejected = rejectedDays.includes(dayOfMonth);

      return {
        label: date.toLocaleDateString("en-US", { weekday: "short" }),
        formattedDate,
        dayOfMonth,
        isWeekend,
        isHoliday,
        isRejected,
      };
    });

    const formatHoursForExport = (value?: string) => {
      if (!value || value.trim() === "" || value.trim() === "0") {
        return "0:00";
      }
      return value.includes(".") ? value.replace(".", ":") : value;
    };

    const tableData = timesheetData
      .filter(
        (row) =>
          row.project_activity_ids !== "" && row.task_description.trim() !== "",
      )
      .map((row) => ({
        project:
          activity?.find((item) => item.id === row.project_activity_ids)
            ?.name || "",
        description: row.task_description,
        days: weekMeta.map((_, idx) =>
          formatHoursForExport(row.days_data[idx]?.hours),
        ),
      }));

    const employeeName = employeeNameData || "Employee";
    const approverName =
      timesheetHistory?.data
        ?.filter(
          (item) =>
            item?.report_statuses_id === ReportStatusEnum.Approved ||
            item?.report_statuses_id === ReportStatusEnum.PartiallyApproved,
        )
        .map((item) => item.status_user_id)
        .join(", ") ?? "N/A";

    exportTimesheetPDF(
      `${formattedStartDate} - ${formattedEndDate}`,
      employeeName,
      approverName,
      tableData,
      weekMeta,
      statusHistory,
    );
  };

  const handleSave = () => {
    const isValid = validateData();
    if (isValid) {
      handleSubmitPayload(ReportStatusEnum.New);
    }
  };

  const onSubmitToApproval = () => {
    const isValid = validateData();
    if (isValid) {
      handleSubmitPayload(ReportStatusEnum.Waitingforapproval);
    }
  };

  const addRow = () => {
    if (selectedWeek) {
      const newRow: createTimesheetModal = {
        project_activity_ids: "",
        task_description: "",
        days_data: getInitialHours(selectedWeek),
      };
      setTimesheetData([...timesheetData, newRow]);
    }
  };

  const removeRow = (index: number) => {
    setTimesheetData((prevData) => prevData.filter((_, i) => i !== index));
  };

  const updateRow = (
    id: number,
    field: string,
    value: string | number | HourModel[],
  ) => {
    if (field === "project_activity_ids" && id === timesheetData.length - 1) {
      addRow();
    }

    // Update the specific row in timesheetData
    setTimesheetData((prevData) =>
      prevData.map((item, index) =>
        index === id ? { ...item, [field]: value } : item,
      ),
    );

    if (field === "project_activity_ids" && value === "") {
      removeRow(id); // Remove the row if the field is "project_activity_ids" and value is empty
    }
    return;
  };

  const handleClickMissingTimeSheet = (item: MissingTimesheet) => {
    if (item) {
      const prevWeek = new Date(item.end_date);
      setCookieData(
        "timesheetsReport",
        JSON.stringify({
          id:
            moment(item.start_date).format("D MMM YYYY") +
            " - " +
            moment(item.end_date).format("D MMM YYYY"),
          memberID: memberID,
          role: cookeei?.role ?? "",
        }),
      );
      const getpayload = {
        start_date: moment(item.start_date).format("DD-MM-YYYY"),
        end_date: moment(item.end_date).format("DD-MM-YYYY"),
        user_id: Number(item.iontime_id),
      };
      getTimeSheet(getpayload, prevWeek);
      setSelectedWeek(prevWeek);
    }
  };
  // console.log('sj==>', checkResponseData)
  return (
    <div>
      {showHomeButton && (
        <div className="mb-4 flex items-center gap-3">
          <button
            onClick={() => navigate("/")}
            className="px-4 py-2 bg-gray-900 text-white rounded-lg focus:outline-none hover:bg-gray-600"
          >
            Back to Home
          </button>
          <BackButton fallbackPath="/" />
        </div>
      )}
      <div className=" h-100 bg-white dark:bg-gray-800  sm:rounded-lg">
        {userRoleType === "finance" &&
          !ReportFormButtonPermissionStatusEnum.user.includes(
            timesheetData[0]?.report_statuses_id as 2 | 3 | 5 | 6 | 7,
          ) && (
            <p className="text-md text-red-600 text-left">
              Timesheet not submited
            </p>
          )}
        {userRoleType !== "finance" && employeeIDData && (
          <p className="text-md text-gray-600 dark:text-white text-left">
            Employee Id: {employeeIDData}
          </p>
        )}
        {userRoleType !== "finance" && employeeNameData && (
          <p className="text-md text-gray-600 dark:text-white text-left mb-4">
            Employee Name: {employeeNameData}
          </p>
        )}
        {userRoleType !== "finance" &&
          (!showapproveReject ||
            !ReportFormButtonPermissionStatusEnum.user.includes(
              timesheetData[0]?.report_statuses_id as 2 | 3 | 5 | 6 | 7,
            )) &&
          missingTimeSheet && (
            <div className="text-md text-gray-600 dark:text-white text-left my-4">
              <div className="mb-2">
                <label
                  htmlFor="missing"
                  className="block mb-2 text-lg font-medium text-gray-900 dark:text-white"
                >
                  Missing timesheet
                </label>

                {missingTimeSheet.map((item, idx) => (
                  <button
                    key={
                      item.reports_id ??
                      `${item.start_date}-${item.end_date}-${idx}`
                    }
                    onClick={() => handleClickMissingTimeSheet(item)}
                    className={` ${
                      moment(selectedWeek, "DD-MM-YYYY").isSame(
                        item.start_date,
                        "day",
                      ) ||
                      moment(selectedWeek, "DD-MM-YYYY").isSame(
                        item.end_date,
                        "day",
                      )
                        ? "bg-yellow-100  text-gray-700 hover:bg-yellow-200 border-yellow-400"
                        : "bg-blue-100 border-blue-400  text-blue-800 hover:bg-blue-200"
                    } text-sm font-medium me-2 my-1 px-2.5 py-0.5 rounded  border  inline-flex items-center justify-center`}
                  >
                    {moment(item.start_date).format("DD/MM/YYYY")} -{" "}
                    {moment(item.end_date).format("DD/MM/YYYY")}
                  </button>
                ))}
              </div>
            </div>
          )}

        {!checkResponseData && (
          <WeekPicker
            report_statuses_id={
              !ReportFormButtonPermissionStatusEnum.user.includes(
                timesheetData[0]?.report_statuses_id as 2 | 3 | 5 | 6 | 7,
              )
                ? true
                : false
            }
            showapproveReject={
              userRoleType === "manager" || userRoleType === "admin"
                ? false
                : showapproveReject
            }
            report_id={timesheetData[0]?.report_statuses_id ?? null}
            selectedWeek={selectedWeek}
            userType={userRoleType}
            setSelectedWeek={setSelectedWeek}
            onNextWeek={onNextWeek}
            onPrevWeek={onPrevWeek}
            onSave={handleSave}
            onSubmitToApproval={onSubmitToApproval}
            showExportButtons={showExportButton}
            onExport={() => onExport("divToPrint")}
            isNextWeekDisabled={isNextWeekDisabled}
          />
        )}

        {showExportButton && (
          <div className="text-right">
            <button
              onClick={() => onExport("divToPrint")}
              className="flex items-center px-4 py-2 text-sm bg-blue-500 text-white rounded-lg focus:outline-none hover:bg-blue-600"
            >
              <ArrowDownTrayIcon className="h-5 w-5 mr-2" />
              Export to PDF
            </button>
          </div>
        )}

        <div className="text-sm text-gray-600 dark:text-white text-left my-4">
          Note: Kindly apply leaves in GreytHR
        </div>
        <div className="text-sm text-red-600 text-center">{errorMessages}</div>
        {!checkResponseData && (
          <div id="divToPrint" className="relative">
            <div className="w-full overflow-x-auto overflow-y-hidden">
              <table className="table-auto min-w-[68rem] sm:min-w-[78rem] w-max lg:w-full border my-2 border-gray-300 text-[11px] sm:text-xs md:text-sm text-left text-gray-500">
                <thead className="text-xs text-center text-gray-700 uppercase border-b border-t dark:border-0 bg-gray-100">
                  <tr className="">
                    <th className=" bg-gray-100 px-2 py-3 w-64 md:w-80 text-center text-xs capitalize">
                      Project Name - Activity
                    </th>
                    <th className="px-2 py-3 w-48 md:w-64 text-center text-xs capitalize">
                      Description/Status Report
                    </th>
                    {getWeekDates(selectedWeek).map((date, index) => (
                      <th
                        key={index}
                        className={` px-2 py-3 ${
                          ((index === 0 ||
                            getWeekDates(selectedWeek).slice(0, -1).length ===
                              index) &&
                            " bg-indigo-50  ") ||
                          (rejectedDate?.includes(date.getDate()) &&
                            "bg-red-50 ") ||
                          (holidaysData.includes(
                            moment(date).format("DD-MM-YYYY"),
                          ) &&
                            " bg-green-50 ")
                        }`}
                      >
                        <div className="flex flex-col items-center">
                          <span className="uppercase text-xs">
                            {date.toLocaleDateString("en-US", {
                              weekday: "short",
                            })}
                          </span>
                          <span className="capitalize lg:flex text-xs items-center w-max">
                            {date
                              .toLocaleDateString("en-US", { month: "short" })
                              .toLowerCase()}{" "}
                            {date.getDate()} (HH.MM)
                          </span>
                        </div>
                      </th>
                    ))}
                    <th className="sticky top-0 px-1 py-2 bg-gray-100 text-xs">
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white ">
                  {timesheetData.length > 0 &&
                    timesheetData.map((row, index) => (
                      <CustomTimeSheetTableRow
                        key={index}
                        previewFlag={
                          !ReportFormButtonPermissionStatusEnum.user.includes(
                            timesheetData[0]?.report_statuses_id as
                              | 2
                              | 3
                              | 5
                              | 6
                              | 7,
                          )
                            ? true
                            : false
                        }
                        report_statuses_id={
                          userRoleType === "finance"
                            ? false
                            : userRoleType !== "finance" &&
                                !ReportFormButtonPermissionStatusEnum.user.includes(
                                  timesheetData[0]?.report_statuses_id as
                                    | 2
                                    | 3
                                    | 5
                                    | 6
                                    | 7,
                                )
                              ? true
                              : false
                        }
                        report_id={timesheetData[0]?.report_statuses_id ?? null}
                        mainIndex={index}
                        row={row}
                        userType={userRoleType}
                        daysData={holidaysData}
                        timesheetData={timesheetData}
                        updateRow={updateRow}
                        removeRow={removeRow}
                        rejectedDates={rejectedDate ?? null}
                        showRemove={index !== timesheetData.length - 1}
                      />
                    ))}
                </tbody>
                <tfoot className=" bg-gray-100 text-gray-900">
                  <tr>
                    <td className=" px-2 py-2 font-medium text-xs text-center">
                      Total Hours
                    </td>
                    <td className="px-2 py-2 font-medium text-xs text-center"></td>
                    {getWeekDates(selectedWeek).map((date, index) => (
                      <td
                        key={index}
                        className={`px-2 py-3 text-center ${
                          ((index === 0 ||
                            getWeekDates(selectedWeek).slice(0, -1).length ===
                              index) &&
                            " bg-indigo-50 ") ||
                          (rejectedDate?.includes(date.getDate()) &&
                            "bg-red-50 ") ||
                          (holidaysData.includes(
                            moment(date).format("DD-MM-YYYY"),
                          ) &&
                            " bg-green-50 ")
                        }`}
                      >
                        {calculateTotalHoursPerDay(index)}
                      </td>
                    ))}
                    <td className="px-2 py-2 font-medium text-xs text-center">
                      {timesheetData
                        .reduce((total, row) => {
                          return (
                            total +
                            row.days_data.reduce((dayTotal, { hours }) => {
                              const [hoursInt, minutesInt] = hours
                                .split(".")
                                .map(Number);
                              return (
                                dayTotal + hoursInt + (minutesInt || 0) / 60
                              );
                            }, 0)
                          );
                        }, 0)
                        .toFixed(2)}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div className="my-4">
              <div>
                <span
                  id={`badge-dismiss-indigo`}
                  className={`inline-flex capitalize items-center px-2 py-1 me-2 text-xs font-medium text-indigo-800 bg-indigo-50 rounded`}
                >
                  Week End{" "}
                </span>
                <span
                  id={`badge-dismiss-green`}
                  className={`inline-flex capitalize items-center px-2 py-1 me-2 text-xs font-medium text-green-800 bg-green-50 rounded`}
                >
                  Public Holiday{" "}
                </span>
                <span
                  id={`badge-dismiss-red`}
                  className={`inline-flex capitalize items-center px-2 py-1 me-2 text-xs font-medium text-red-800 bg-red-50 rounded`}
                >
                  Rejected Dates
                </span>
              </div>
            </div>

            {userRoleType !== "finance" &&
              showapproveReject &&
              (userRoleType === "admin" || userRoleType === "manager") &&
              timesheetData &&
              timesheetData.length > 0 && (
                <div className="my-4">
                  <ApproveRejectForm
                    report_id={timesheetData[0].report_id ?? null}
                    checkapproved={
                      timesheetData[0]?.report_statuses_id ===
                        ReportStatusEnum.Waitingforapproval ||
                      timesheetData[0]?.report_statuses_id ===
                        ReportStatusEnum.PartiallyApproved
                        ? true
                        : false
                    }
                    showapproveReject={
                      timesheetData[0]?.report_statuses_id ===
                      ReportStatusEnum.Returnedforreview
                    }
                    daysRecord={getWeekDates(selectedWeek)}
                    modelClose={modelClose}
                  />
                </div>
              )}

            {timesheetHistory?.data.map((item) =>
              item.report_statuses_id === ReportStatusEnum.Approved ||
              item.report_statuses_id === ReportStatusEnum.PartiallyApproved ? (
                <div
                  key={item.id}
                  className="text-sm text-gray-600 dark:text-gray-500"
                >
                  <span className="text-gray-400"> Approved on : </span>
                  {moment(item.status_create_ts).isValid() &&
                    moment(item.status_create_ts).format("DD-MM-YYYY HH:mm:ss")}
                  <span className="text-gray-400"> By : </span>
                  {item.status_user_id}
                  <span className="text-gray-400"> Remark : </span>
                  {item.rejected_reason ? item.rejected_reason : "NA"}
                </div>
              ) : item.report_statuses_id ===
                ReportStatusEnum.Returnedforreview ? (
                <div
                  key={item.id}
                  className="text-sm text-gray-600 dark:text-gray-500"
                >
                  <span className="text-gray-400"> Rejected on : </span>{" "}
                  {moment(item.status_create_ts).isValid() &&
                    moment(item.status_create_ts).format("DD-MM-YYYY HH:mm:ss")}
                  <span className="text-gray-400"> By : </span>{" "}
                  {item.status_user_id}
                  <span className="text-gray-400"> Reason : </span>{" "}
                  {item.rejected_reason}{" "}
                  <span className="text-gray-400"> Dates rejected : </span>{" "}
                  {item.rejected_dates}{" "}
                </div>
              ) : (
                <div
                  key={item.id}
                  className="text-sm text-gray-600 dark:text-gray-500"
                >
                  <span className="text-gray-400">
                    {" "}
                    Submitted for approval on :{" "}
                  </span>
                  {moment(item.status_create_ts).isValid() &&
                    moment(item.status_create_ts).format("DD-MM-YYYY HH:mm:ss")}
                  <span className="text-gray-400"> By : </span>
                  {item.status_user_id}
                </div>
              ),
            )}

            {/* <h5 className='capitalize py-3'>Legend</h5>
        <div className='text-xs'>
          {activity &&
            Array.from(
              new Set(
                activity.map((item) => item.name.split(" - ")[0]), // Split by space and take the first part
              ),
            ).map((projectName, index) => (
              <span
                className='bg-blue-100 text-blue-800 text-xs font-medium inline-flex items-center m-1 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-blue-400 border border-blue-400'
                key={index}
              >
                {index > 0 ? ` ${projectName}` : projectName}
              </span>
            ))}
        </div> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomTimeSheetTable;
